import { useNavigate } from 'react-router-dom';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import 'primeflex/primeflex.css';

const EditorHome = () => {
  const navigate = useNavigate();

  const pagesEditor = [
    {
      title: "Importar nuevos empleados ",
      description: "Concilie e importe los empleados desde Humand API para ser creados en Nomina GSM.",
      path: "/editor/empleados/listado",
      label: "Importar empleados",
      icon: "pi pi-users",
      color: "bg-blue-100 text-blue-800"
    },    
    {
      title: "Crear empleados",
      description: "Cree empleados para Nomina GSM.",
      path: "/editor/empleados/transferir",
      label: "Crear empleados",
      icon: "pi pi-users",
      color: "bg-yellow-100 text-yellow-800"
    },
    {
      title: "Transferir incidencias",   
      description: "Transfiera las faltas y vacaciones para determinar los dias trabajados para el concepto de tiempos normales para el periodo actual.",
      path: "/editor/incidencias/transferir",
      label: "Trasferir incidencias",
      icon: "pi pi-calendar-times",
      color: "bg-red-100 text-red-800"
    },
    {
      title: "Transferir bonos",
      description: "Transfiera los bonos capturados para el periodo actual.",
      path: "/editor/bonos/transferir",
      label: "Importar bonos",
      icon: "pi pi-gift",
      color: "bg-green-100 text-green-800"
    },
    {
      title: "Vacaciones",
      description: "Listo de vacaciones desde Humand.",
      path: "/editor/vacaciones/listado",
      label: "Ver vacaciones",
      icon: "pi pi-user-minus",
      color: "bg-cyan-100 text-cyan-800"
    },
    
    {
      title: "Solicitudes de bajas",
      description: "Revise y aplique las solicitudes de baja de empleados.",
      path: "/editor/bajas/listado",
      label: "Solicitudes de baja",
      icon: "pi pi-user-minus",
      color: "bg-red-100 text-red-800"
      
    },
    // {
    //   title: "Captura de bonos",
    //   description: "Registre los bonos a los empleados para el periodo actual.",
    //   path: "/bonos",
    //   label: "Capturar bonos",
    //   icon: "pi pi-gift",
    //   color: "bg-green-100 text-green-800"
    // },
    // {
    //   title: "Cambios de salario",
    //   description: "Capture solicitudes de cambio de salario por empleado.",
    //   path: "/cambio-salario",
    //   label: "Registrar solicitud",
    //   icon: "pi pi-wallet",
    //   color: "bg-yellow-100 text-yellow-800"
    // },
    // {
    //   title: "Solicitudes de bajas",
    //   description: "Capture las bajas de empleados.",
    //   path: "/baja-empleados",
    //   label: "Registrar baja",
    //   icon: "pi pi-user-minus",
    //   color: "bg-purple-100 text-purple-800"
    // }
  ];

  return (
    <div className="p-4">
      <h1 className="mb-4 text-2xl font-bold">Inicio de editor de nomina</h1>

      <div className="grid">
        {pagesEditor.map((page, idx) => (
          <div key={idx} className="col-12 md:col-4">
            <Card className="h-full shadow-2 border-round p-3">
              <div className={`flex items-center gap-2 text-lg font-bold mb-2 p-2 border-round ${page.color}`}>
                <i className={page.icon}></i>
                {page.title}
              </div>
              <p className="text-gray-700 mb-3">{page.description}</p>
              <Button
                label={page.label}
                className="bg-cyan-500 hover:bg-cyan-600 border-none"
                icon="pi pi-arrow-right"
                onClick={() => navigate(page.path)}
              />
            </Card>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EditorHome;
